/**
 * @fileoverview Syndicator Showdown — Phase 5: Notification preferences (client)
 * @module utils/notificationPreferences
 *
 * Mirrors functions/src/notifications/notificationPreferences.js — keep the
 * two DEFAULT_NOTIFICATION_PREFERENCES objects in sync. Duplicated (rather
 * than shared via @ss/shared) to keep this a tiny, dependency-free client
 * util; the shapes are simple enough that drift risk is low and each side
 * already documents the link back to the other.
 */

export const DEFAULT_NOTIFICATION_PREFERENCES = Object.freeze({
  inApp:                   true,
  emailUpcomingRunner:     true,
  emailRaceResult:         true,
  // P0 fix (2026-07-05): gates the "new Showdown opening in 30 minutes"
  // blast. Promotional/game-opening copy, not a core transactional
  // result/race alert — default-OFF, opt-in only. Was previously named
  // `emailGameOpen` (default true) — see getNotificationPreferences() below
  // for the one-time legacy fallback that honours an explicit old value.
  emailNewShowdownOpening: false,
  emailStableShare:        false,
  emailSystem:             false,
  emailMarketing:          false,
  emailScratchingAlerts:   true,
  quietHoursEnabled:       false,
  quietHoursStart:         null,
  quietHoursEnd:           null,
  timezone:                'Australia/Brisbane',
});

const LEGACY_GAME_OPEN_FIELD = 'emailGameOpen';

/** Merges a user doc's stored preferences over the safe defaults. */
export function getNotificationPreferences(userDoc) {
  const stored = (userDoc && userDoc.notificationPreferences) || {};
  const merged = { ...DEFAULT_NOTIFICATION_PREFERENCES, ...stored };

  // Honour an explicit choice saved under the pre-rename field name rather
  // than silently resetting the user to the new opt-in-only default.
  if (stored.emailNewShowdownOpening === undefined && stored[LEGACY_GAME_OPEN_FIELD] !== undefined) {
    merged.emailNewShowdownOpening = stored[LEGACY_GAME_OPEN_FIELD] === true;
  }

  return merged;
}
